import { TRACKERS } from "@/constants/Trackers";
import { Vitals } from "@/features/Patient/MedicalRecords/Vitals/Vitals";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/vitals")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_VITALS);
  },
});

function RouteComponent() {
  return <Vitals />;
}
